<i18n lang="yaml">
  ru:
    ActionSidebarTextTitle: "Настройки текста"
    ActionSidebarTextPlaceholderText: "Сообщение призыва к действию"
    ActionSidebarTextExtraTextEnabled: "Расширенные настройки"
    ActionSidebarTextExtraWhatsappText: "Кнопка WhatsApp"
    ActionSidebarTextExtraWhatsappQrcode: "QR-код WhatsApp"
    ActionSidebarTextExtraTelegramText: "Кнопка Telegram"
    ActionSidebarTextExtraTelegramQrcode: "QR-код Telegram"
  en:
    ActionSidebarTextTitle: "Settings the text"
    ActionSidebarTextPlaceholderText: "C call to action"
    ActionSidebarTextExtraTextEnabled: "Advanced settings"
    ActionSidebarTextExtraWhatsappText: "WhatsApp button"
    ActionSidebarTextExtraWhatsappQrcode: "QR-code WhatsApp"
    ActionSidebarTextExtraTelegramText: "Telegram button"
    ActionSidebarTextExtraTelegramQrcode: "QR-code Telegram"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarTextTitle')"
  >
    <div :class="$style.actionSidebarTextContainer">
      <PWTextarea
        v-model="modalTextLocal"
        :placeholder="$t('ActionSidebarTextPlaceholderText')"
        :is-error="$v.modalTextLocal.$error"
      >
        <template v-if="!$v.modalTextLocal.required">
          {{ $t('requiredField') }}
        </template>
        <template v-else>
          {{ modalTextLocal.length }} {{ $t('from') }} 200
        </template>
      </PWTextarea>

      <button
        :class="$style.actionSidebarTextExtraButton"
        @click="extraTextEnabledLocal = !extraTextEnabledLocal"
      >
        <RemoveRounded
          v-if="extraTextEnabledLocal"
          :class="$style.actionSidebarTextExtraButtonIcon"
        />
        <AddRounded
          v-else
          :class="$style.actionSidebarTextExtraButtonIcon"
        />
        <span :class="$style.actionSidebarTextExtraButtonLabel">
          {{ $t('ActionSidebarTextExtraTextEnabled') }}
        </span>
      </button>

      <template v-if="extraTextEnabledLocal">
        <PWInput
          v-show="showWhatsappFields"
          v-model="whatsappButtonTextLocal"
          :placeholder="$t('ActionSidebarTextExtraWhatsappText')"
          :is-error="$v.whatsappButtonTextLocal.$error"
        >
          {{ getTipForExtraInputs(whatsappButtonTextLocal.length, !$v.whatsappButtonTextLocal.required) }}
        </PWInput>

        <PWInput
          v-show="showWhatsappFields"
          v-model="whatsappQrcodeTextLocal"
          :placeholder="$t('ActionSidebarTextExtraWhatsappQrcode')"
          :is-error="$v.whatsappQrcodeTextLocal.$error"
        >
          {{ getTipForExtraInputs(whatsappQrcodeTextLocal.length, !$v.whatsappQrcodeTextLocal.required) }}
        </PWInput>

        <PWInput
          v-show="showTelegramFields"
          v-model="telegramButtonTextLocal"
          :placeholder="$t('ActionSidebarTextExtraTelegramText')"
          :is-error="$v.telegramButtonTextLocal.$error"
        >
          {{ getTipForExtraInputs(telegramButtonTextLocal.length, !$v.telegramButtonTextLocal.required) }}
        </PWInput>

        <PWInput
          v-show="showTelegramFields"
          v-model="telegramQrcodeTextLocal"
          :placeholder="$t('ActionSidebarTextExtraTelegramQrcode')"
          :is-error="$v.telegramQrcodeTextLocal.$error"
        >
          {{ getTipForExtraInputs(telegramQrcodeTextLocal.length, !$v.telegramQrcodeTextLocal.required) }}
        </PWInput>
      </template>
    </div>
  </PWAsideBodyItem>
</template>

<script>
/**
 * Utils
 */
import required from 'vuelidate/lib/validators/required'
import maxLength from 'vuelidate/lib/validators/maxLength'
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWTextarea from '@/components/_ui/PWTextarea.vue'
import PWInput from '@/components/_ui/PWInput.vue'
/**
 * Static
 */
import AddRounded from '@/assets/icons/AddRounded.svg?inline'
import RemoveRounded from '@/assets/icons/RemoveRounded.svg?inline'

export default {
  components: {
    PWAsideBodyItem,
    PWTextarea,
    AddRounded,
    RemoveRounded,
    PWInput
  },
  validations () {
    return {
      modalTextLocal: {
        required,
        maxLengthValue: maxLength(200)
      },
      whatsappButtonTextLocal: {
        required,
        maxLengthValue: maxLength(40)
      },
      whatsappQrcodeTextLocal: {
        required,
        maxLengthValue: maxLength(40)
      },
      telegramButtonTextLocal: {
        required,
        maxLengthValue: maxLength(40)
      },
      telegramQrcodeTextLocal: {
        required,
        maxLengthValue: maxLength(40)
      }
    }
  },
  props: {
    redirect: {
      type: String,
      default: 'whatsapp'
    },
    modalText: {
      type: String,
      default: ''
    },
    extraTextEnabled: {
      type: Boolean,
      default: false
    },
    whatsappButtonText: {
      type: String,
      default: ''
    },
    whatsappQrcodeText: {
      type: String,
      default: ''
    },
    telegramButtonText: {
      type: String,
      default: ''
    },
    telegramQrcodeText: {
      type: String,
      default: ''
    }
  },
  computed: {
    showWhatsappFields () {
      return this.redirect === 'whatsapp' || this.redirect === 'whatsapp-and-telegram'
    },

    showTelegramFields () {
      return this.redirect === 'telegram' || this.redirect === 'whatsapp-and-telegram'
    },

    modalTextLocal: {
      get () { return this.modalText },
      async set (val) {
        this.$emit('update-modalText', val)
        await this.$v.$touch()
        this.$emit('handle-validation', this.$v.modalTextLocal.$error)
      }
    },
    extraTextEnabledLocal: {
      get () { return this.extraTextEnabled },
      set (val) { this.$emit('update-extraTextEnabled', val) }
    },
    whatsappButtonTextLocal: {
      get () { return this.whatsappButtonText },
      async set (val) {
        this.$emit('update-whatsappButtonText', val)
        await this.$v.$touch()
        this.$emit(
          'handle-validation',
          this.extraTextEnabledLocal
            ? this.$v.$error
            : false
        )
      }
    },
    whatsappQrcodeTextLocal: {
      get () { return this.whatsappQrcodeText },
      async set (val) {
        this.$emit('update-whatsappQrcodeText', val)
        await this.$v.$touch()
        this.$emit(
          'handle-validation',
          this.extraTextEnabledLocal
            ? this.$v.$error
            : false
        )
      }
    },
    telegramButtonTextLocal: {
      get () { return this.telegramButtonText },
      async set (val) {
        this.$emit('update-telegramButtonText', val)
        await this.$v.$touch()
        this.$emit(
          'handle-validation',
          this.extraTextEnabledLocal
            ? this.$v.$error
            : false
        )
      }
    },
    telegramQrcodeTextLocal: {
      get () { return this.telegramQrcodeText },
      async set (val) {
        this.$emit('update-telegramQrcodeText', val)
        await this.$v.$touch()
        this.$emit(
          'handle-validation',
          this.extraTextEnabledLocal
            ? this.$v.$error
            : false
        )
      }
    }
  },
  methods: {
    getTipForExtraInputs (len, requiredError) {
      return requiredError
        ? this.$t('requiredField')
        : `${len} ${this.$t('from')} 40`
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.actionSidebarTextExtraButton {
  all: unset;
  display: inline-flex;
  color: var(--main-blue);
  gap: 8px;
  align-items: center;
  cursor: pointer;
}

.actionSidebarTextExtraButtonIcon {
  --s: 20px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarTextExtraButtonLabel {
  color: currentColor;
  user-select: none;

  @include mixins.body2;
}

.actionSidebarTextContainer {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
